import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { VersionForceRefreshWrapper } from 'ui';
import { TranslationEn } from '../../../../assets/i18n/en';

@Component({
	selector: 'rc-version-popup-wrapper',
	template: `<div #reactContainer></div>`,
})
export class VersionPopupWrapperComponent implements OnInit, OnDestroy {
	@ViewChild('reactContainer', { static: true }) private reactContainer: ElementRef;

	labels = TranslationEn.forceRefresh;

	ngOnInit() {
		this.renderReactComponent();
	}

	ngOnDestroy() {
		this.unmountReactComponent();
	}

	private renderReactComponent() {
		if (this.reactContainer?.nativeElement) {
			// Create React element - the component manages its own state
			const reactElement = React.createElement(VersionForceRefreshWrapper, {
				labels: this.labels,
			});

			// Render React component
			ReactDOM.render(reactElement, this.reactContainer.nativeElement);
		}
	}

	private unmountReactComponent() {
		if (this.reactContainer?.nativeElement) {
			ReactDOM.unmountComponentAtNode(this.reactContainer.nativeElement);
		}
	}
}
